import { Container } from '@vilibets/vilibets-uikit/dist/atoms/Container';
import { Loading } from '@vilibets/vilibets-uikit/dist/atoms/Loading';
import { ResetPassword } from '@vilibets/vilibets-uikit/dist/molecules/ResetPassword';
import { Footer } from '@vilibets/vilibets-uikit/dist/organisms/Footer';
import { PublicHeader } from '@vilibets/vilibets-uikit/dist/organisms/PublicHeader';
import { Expand } from '@theme-toggles/react';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useLoading } from '../../context/LoadingContext';
import { useAuth } from '../../hooks/auth';

const ResetPasswordComponent = () => {
  const { resetPassword } = useAuth({
    middleware: 'guest',
  });
  const { dispatch } = useLoading();
  const {
    state: { loading },
  } = useLoading();
  const [searchParams] = useSearchParams();
  const { token, email } = Object.fromEntries([...searchParams]);

  const [error, setErrors] = useState(0);
  const [status, setStatus] = useState(null);

  const submitForm = async (event) => {
    dispatch({ type: 'isLoading' });
    const { password, code, repeatPassword } = event;
    if (token !== undefined && email !== undefined) {
      resetPassword({ token, email, password, password_confirmation: repeatPassword, setErrors, setStatus });
    } else if (token !== undefined && email === undefined) {
      const { email } = event;
      resetPassword({ token, email, password, password_confirmation: repeatPassword, setErrors, setStatus });
    } else if (token === undefined && email !== undefined) {
      const token = code;
      resetPassword({ email, token, password, password_confirmation: repeatPassword, setErrors, setStatus });
    } else {
      const { email, code } = event;
      const token = code;
      resetPassword({ token, email, password, password_confirmation: repeatPassword, setErrors, setStatus });
    }
  };

  const [isDarkMode, setIsDarkMode] = useState(localStorage.theme === 'dark');

  useEffect(() => {
    // toLightMode();
    if (localStorage.theme === 'dark') {
      toDarkMode();
    } else {
      toLightMode();
    }
  }, []);

  const toDarkMode = () => {
    localStorage.theme = 'dark';
    setIsDarkMode(true);
    updateTheme();
  };

  const toLightMode = () => {
    localStorage.theme = 'light';
    setIsDarkMode(false);
    updateTheme();
  };

  function updateTheme() {
    switch (localStorage.theme) {
      case 'dark':
        document.documentElement.classList.add('dark');
        document.documentElement.setAttribute('color-theme', 'dark');
        break;
      case 'light':
        document.documentElement.classList.remove('dark');
        document.documentElement.setAttribute('color-theme', 'light');
        break;
    }
  }

  return (
    <>
      {loading && <Loading />}
      <PublicHeader
        header_links={[
          { name: 'Descubre cómo funciona', route: process.env.REACT_APP_PUBLIC_PAGE_URL + '/como-funciona' },
          { name: 'Bonos bienvenida', route: process.env.REACT_APP_PUBLIC_PAGE_URL + '/bonos-lista' },
          {
            name: 'Curso',
            route: process.env.REACT_APP_PUBLIC_PAGE_URL + '/curso',
          },
          { name: 'Comunidad', route: process.env.REACT_APP_PUBLIC_PAGE_URL + '/comunidad' },
          { name: 'Tarifas', route: process.env.REACT_APP_PUBLIC_PAGE_URL + '/tarifas' },
          { name: 'Contacto', route: process.env.REACT_APP_PUBLIC_PAGE_URL + '/contacto' },
        ]}
        toggleIcon={
          <Expand
            toggled={isDarkMode}
            onToggle={() => {
              if (localStorage.theme === 'dark') {
                toLightMode();
              } else {
                toDarkMode();
              }
            }}
          />
        }
        route_access={'/login'}
        route_try_now={'/register'}
      />
      {status?.status && <Navigate to="/login" />}
      <main className="bg-primary-1 pt-16 pb-20 h-screen flex">
        <Container>
          <div className="m-auto h-full w-[347px] md:w-[400px] lg:w-[400px] justify-center items-center">
            <ResetPassword
              showCode={typeof token === 'undefined'}
              showEmail={typeof email === 'undefined'}
              submitForm={(e) => {
                submitForm(e);
              }}
              hasErrorInput={Object.keys(error).length > 0}
              textButton={'Cambiar contraseña'}
              textError={t(`${error.status}.${error.message}`)}
            />
          </div>
        </Container>
      </main>
      <footer className="fixed bottom-0 w-screen bg-white">
        <Footer type="simple" />
      </footer>
    </>
  );
};

export default ResetPasswordComponent;
